export const HERO_TITLE_TEXT = 'What emails can I help you'

let hasPlayedHeroTitle = false

export function shouldAnimateHeroTitle(): boolean {
  return !hasPlayedHeroTitle
}

export function markHeroTitlePlayed(): void {
  hasPlayedHeroTitle = true
}

export function resetHeroTitlePlaybackForTests(): void {
  hasPlayedHeroTitle = false
}

export type HeroTitlePlaybackState = {
  shouldAnimate: boolean
  charCount: number
  hasStarted: boolean
}

export function getHeroTitlePlaybackState(): HeroTitlePlaybackState {
  if (hasPlayedHeroTitle) {
    return {
      shouldAnimate: false,
      charCount: HERO_TITLE_TEXT.length,
      hasStarted: true,
    }
  }

  return {
    shouldAnimate: true,
    charCount: 0,
    hasStarted: false,
  }
}
